import { render, staticRenderFns } from "./Develop.vue?vue&type=template&id=fee442da&scoped=true&"
import script from "./Develop.vue?vue&type=script&lang=js&"
export * from "./Develop.vue?vue&type=script&lang=js&"
import style0 from "./Develop.vue?vue&type=style&index=0&id=fee442da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee442da",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fee442da')) {
      api.createRecord('fee442da', component.options)
    } else {
      api.reload('fee442da', component.options)
    }
    module.hot.accept("./Develop.vue?vue&type=template&id=fee442da&scoped=true&", function () {
      api.rerender('fee442da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Develop.vue"
export default component.exports